import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { MakeCallComponent } from '../../client-lead/make-call/make-call.component';

@Component({
  selector: 'app-ivr-call-dashboard',
  templateUrl: './ivr-call-dashboard.component.html',
  styleUrls: ['./ivr-call-dashboard.component.scss']
})
export class IvrCallDashboardComponent implements OnInit {
  authToken = localStorage.getItem("token");
  constructor(
    public clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private serverService: ServerService,
    private router: Router,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<MakeCallComponent>,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
  }

  goTo(router: any) {
    if (router == 'project-dashboard') {
      this.router.navigate(['/page/project-wise-call-dashboard'])
    } else if (router == 'telecaller-dashboard') {  
        this.router.navigate(['/page/telecaller-wise-call-dashboard'])     
    } else if (router == 'client-wise-lead-dashboard'){
      this.router.navigate(['/page/client-wise-lead-dashboard'])
    } else if(router == 'project-wise-lead-dashboard'){
      this.router.navigate(['/page/project-wise-lead-dashboard'])
    } else if(router == 'project-wise-source-dashboard'){
      this.router.navigate(['/page/project-wise-source-dashboard'])
    }
  }

}
